import * as actionTypes from './actionTypes';
import axios from '../../_services/api/axios';
import { translationLoad } from './translationLoad';

export const appStartupStart = () => {
    return {
        type: actionTypes.APP_STARTUP_START
    };
};

export const appStartupSuccess = (show_service_terms) => {
    return {
        type: actionTypes.APP_STARTUP_SUCCESS,
        show_service_terms
    };
};

export const appStartupFail = () => {
    return {
        type: actionTypes.APP_STARTUP_FAIL
    };
};

export const appStartup = () => {
    const redirectToAcceptServiceTerms = () => {
        const redirectURL = `${process.env.REACT_APP_ACCOUNT_URL}dashboard/terms/${process.env.REACT_APP_PRODUCT_CODE}`;
        window.location.href = redirectURL;
    };
    
    const redirectToAccount = () => {
        const redirectURL = `${process.env.REACT_APP_ACCOUNT_URL}`;
        window.location.href = redirectURL;
    };
    
    return async (dispatch) => {
        dispatch(appStartupStart());
        try {
            const response = await axios.get( `/account/products/${process.env.REACT_APP_PRODUCT_CODE}/startup` );
            if (response.data.show_service_terms) {
                redirectToAcceptServiceTerms();
                dispatch( appStartupFail() ); 
                return;
            }
            dispatch( translationLoad(response.data.default_language))
            dispatch( appStartupSuccess( response.data.show_service_terms ) );
        } catch (error) {
            redirectToAccount();
            dispatch( appStartupFail( error.response ) ); 
        }
    };
};


// WEBPACK FOOTER //
// ./src/_store/actions/appStartup.js